import * as Yup from 'yup';
import { sharedSchema } from '../shared/sharedSchema';

export const schema = Yup.object().shape({
    selectedMedications: Yup.array().min(1, 'Wybierz przynajmniej jedną opcję').required(),
    lastVisitToDoctor: Yup.string().required('Pole wymagane').nullable(),
    additionalDiseases: Yup.string().required('Pole wymagane').nullable(),
    importantInformation: Yup.string().required('Pole wymagane'),
    ...sharedSchema,
});
